/**
 * SourceChip · SP-07 · displays the system and record every fact came from.
 * Small monospaced badge kept visually quiet so it never competes with the fact.
 */
export default function SourceChip({ system, record, className = "" }) {
  return (
    <span
      className={
        "inline-flex items-center gap-1 mos-mono text-[11px] px-1.5 py-0.5 rounded border align-middle " +
        className
      }
      style={{
        background: "#F1F5F9",
        borderColor: "var(--mos-border)",
        color: "var(--mos-text-muted)",
      }}
      title={`Source · ${system} · ${record}`}
    >
      <span className="text-slate-500">{system}</span>
      <span className="text-slate-300">·</span>
      <span className="text-slate-700">{record}</span>
    </span>
  );
}
